module.exports = __webpack_public_path__ + "static/media/bg.ffc4c598.png";